import request from '@/api/request'

export default {
  getToken (payload) {
    const url = '/login_check'
    const data = { email: payload.email, password: payload.password }
    return request({ method: 'POST', url, data })
  },
  refreshToken (payload) {
    const url = '/token/refresh'
    const data = { refreshToken: payload.refreshToken }
    return request({ method: 'POST', url, data })
  },
  logOut () {
    const url = '/logout'
    return request({ method: 'GET', url })
  },
  recoveryPassword () {
    const baseURL = process.env.VUE_APP_END_POINT + '/itp/client'
    const url = '/password/recovery'
    return request({ method: 'GET', baseURL, url })
  },
  resetPassword (payload) {
    const baseURL = process.env.VUE_APP_END_POINT + '/itp/client'
    const url = '/password/reset'
    const data = { email: payload.email, hash: payload.hash }
    return request({ method: 'POST', baseURL, url, data })
  },
  confirmResetPassword (payload) {
    const baseURL = process.env.VUE_APP_END_POINT + '/itp/client'
    const url = '/password/reset/confirm'
    const data = payload
    return request({ method: 'POST', baseURL, url, data })
  }
}
